<template>
    <v-container>
      <v-row>
        <v-col cols="11"> </v-col>
        <v-col cols="1" v-if="showLoader">
          <LoaderProgress></LoaderProgress>
        </v-col>
  
      </v-row>
      
      <div   v-for="[name,value] in widgets_obj_map" :key="name"
      style="border-style=solid"
    >
    <v-row  >
    <v-col>
    <v-btn class='white--text block' dark color='primary' >
    {{ name }}
    </v-btn>
    </v-col>
    </v-row>
     
      <v-row style='margin-bottom: 20px'>
        <div v-bind:key="mac.machine_id" v-for="mac in value">
          <v-col>
            <dpm_card v-bind:properties="mac"  />
          </v-col>
        </div>
      </v-row>
    </div>
    
  
     
    </v-container>
  </template>
  <script>
  import axios from "axios";
  import LoaderProgress from "../components/progressLoader";
  import dpm_card from "../components/DPMCard.vue";
  // import constants from "../constants";
  import router from "../router";
  export default {
  components: {
        LoaderProgress,
        dpm_card
  },
    prop: ["apqData"],

  data: () => ({
    alertsData: [],
     super_data: [],
     showLoader: false,
     widgets_obj_map : new Map(),
  }),

  beforeMount() {
    // console.log("checlong before mouted");
    this.super_user_method();
  },
  methods: {
    goingIntoCustomer (id){
      // console.log("checkign id",id);
                                        sessionStorage.removeItem("route_first_option");

                        sessionStorage.setItem("route_first_option", '/');
                        sessionStorage.setItem("super_to_user_org_id", `${id}`);


      router.push('/')

                //  this.$root.$emit('value_of_checkbox', gag.customer_id);

    },
 timeConverter: (UNIX_timestamp) => {
      // let a = new Date(UNIX_timestamp * 1000);
      let a = new Date((UNIX_timestamp-19800) * 1000);
      let months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      let year = a.getFullYear();
      let month = months[a.getMonth()];
      let date = a.getDate();
      let hour = a.getHours();
      let min = a.getMinutes();
      let sec = a.getSeconds();
      let time =
        date + " " + month + " " + year + " " + hour + ":" + min + ":" + sec;
      return time;
    },
    super_user_method: function() {
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/get_dpm_setup`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.showLoader = true;
      axios(config)
        .then((response) => {
          this.showLoader = false;
          // console.log("response--parameter names", response.data.data);
          let data_list = response.data.data || [];
          // let newValue = [];
          for (let i = 0; i < data_list.length; i++) {
            let group_name = data_list[i].group;
            // console.log("this.data_list[i]",data_list[i]);
            // console.log("this.group_name",group_name);
            if (!this.widgets_obj_map.has(group_name)) {
                  this.widgets_obj_map.set(group_name,[]);
              }
              data_list[i].width = "60%";
              data_list[i].maxwidth = "330px";
              data_list[i].maxwidthOuter = "510px";
              data_list[i].maxheight = "160px";
              data_list[i].maxheightOuter = "300px";
              let timeStamp =  this.timeConverter(data_list[i].time);
              data_list[i].timeStamp = timeStamp;
              
              if (data_list[i].hasAlert == 1 ){
                this.widgets_obj_map.get(group_name).unshift(data_list[i]); // to add elements to the top
              }
              else{
                this.widgets_obj_map.get(group_name).push(data_list[i]);
              }
              
          
          }
          
          // console.log("this.widgets_obj_map",this.widgets_obj_map);
          
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            alert("internal error");
            console.log("axios error", error.message);
          }
        });
    },
  },
};
</script>
<style scoped>
@import "../assets/fonts/style.css";

@media screen and (min-width: 600px) {
  #div2 {
    display: none;
  }
  #ins1 {
    display: none;
  }
}

/* On screens that are 600px wide or less, the background color is olive */
@media screen and (max-width: 600px) {
  #div1 {
    display: none;
  }
  #ins2 {
    display: none;
  }
}

.block {
  display: block;
  width: 100%;
  border: none;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  text-align: left;
}
</style>